// extracted by mini-css-extract-plugin
export var card = "_ip-5";
export var cardSelected = "_ip-4";
export var image = "_ip-3";
export var modal = "_ip-0";
export var modalContent = "_ip-1";
export var table = "_ip-2";